import { Link } from 'react-router-dom';
import { FAQSchema } from '@/shared/seo';
import { SUPPORT_EMAIL } from '@/shared/site';
import { MS_PAGES, msPath, useMsCopy, useMsLocale } from '@/membersheep/i18n';
import { MsHead } from './MsHead';

/** /membersheep/support — the FAQ the App Store's Support URL points to, then email. */
const MsSupportPage = () => {
  const copy = useMsCopy();
  const locale = useMsLocale();
  const { support } = copy;

  return (
    <main className="mx-auto max-w-[calc(68ch+3rem)] px-4 pt-8 md:px-6 md:pt-14">
      <MsHead page={MS_PAGES.support} {...copy.seo.support} />
      <FAQSchema items={support.faq} />

      <Link to={msPath(locale, MS_PAGES.home)} className="text-sm text-ms-accent underline-offset-4 hover:underline dark:text-ms-blue">
        MemberSheep
      </Link>
      <h1 className="mt-2.5 font-display text-[40px] leading-none font-extrabold tracking-[-0.04em] md:text-[52px]">{support.title}</h1>

      <h2 className="mt-9 text-sm text-sys-secondary">{support.faqTitle}</h2>
      <div className="mt-2 border-t border-sys-separator">
        {support.faq.map((item, i) => (
          <details key={item.question} open={i === 0} className="group border-b border-sys-separator">
            <summary className="flex cursor-pointer list-none justify-between gap-4 py-5 font-display text-lg leading-snug font-semibold [&::-webkit-details-marker]:hidden">
              {item.question}
              <span aria-hidden="true" className="text-[22px] leading-none text-ms-accent transition-transform group-open:rotate-45 dark:text-ms-blue">
                +
              </span>
            </summary>
            <p className="mb-5 text-sys-secondary">{item.answer}</p>
          </details>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-5 rounded-[20px] border border-sys-separator bg-sys-surface px-7 py-[26px]">
        <div>
          <h2 className="font-display text-xl font-bold">{support.mailTitle}</h2>
          <p className="mt-1 text-[15px] text-sys-secondary">{support.mailBody}</p>
        </div>
        <a href={`mailto:${SUPPORT_EMAIL}?subject=MemberSheep`} className="rounded-xl bg-ms-accent px-5 py-3 text-[15px] font-semibold text-white dark:bg-ms-blue">
          {SUPPORT_EMAIL}
        </a>
      </div>
    </main>
  );
};

export default MsSupportPage;
